import { useEffect, useRef } from 'react';

function BuyWithPrimeReviews({ sku }) {
  const container = useRef();
  const isBrowser = typeof window !== 'undefined';
  const header = isBrowser ? document.querySelector('header') : 0;
  const observerConfig = {
    subtree: true,
    childList: true,
  };

  const observerCallback = (mutationList) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        // Looks for the iframe added by the Amazon script
        const iframe = container.current.querySelector('iframe');
        if (iframe) {
          // Adds header height + 10 px to the scroll margin so the content doesn't
          // get overlapped by the floating header
          iframe.style.scrollMarginTop = `${header.offsetHeight + 10}px`;
        }
      }
    }
  };

  const observer = isBrowser ? new MutationObserver(observerCallback) : null;

  useEffect(() => {
    if (isBrowser) observer?.observe(container.current, observerConfig);

    return () => {
      if (isBrowser) observer?.disconnect();
    };
  }, []);

  return (
    <div
      data-prime-reviews-sku={sku}
      className="buy-with-prime-reviews-container relative m-auto w-full"
      ref={container}
    >
      <div
        id="amzn-roa-reviews"
        data-site-id="gwfxnozf54"
        data-roa-instance-id="w23suqokp7ni1"
        data-sku={sku}
      />
    </div>
  );
}

export default BuyWithPrimeReviews;
